import React from "react"
import Header from "./Header"
import GameCard from "./GameCard"

import Error from "./../general/Error"

import { debounce, has } from "lodash"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSpinner } from "@fortawesome/free-solid-svg-icons"

const PAGE_SIZE = 50

class Gallery extends React.Component {
    constructor(){
        super()
        this.state = {
            data: [],
            hasMore: true,
            searchFilter: "",
            greenlitFilter: false,
            isLoading: true,
            error: ""
        };
        this.fetchingMore = false
        //fetch the next page when the sentinel below the grid becomes visible
        this.loadMoreObserver = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting){
                this.fetchProjects()
            }
        })
        this.observer = new IntersectionObserver(function(entries, observer){
            entries.forEach(entry =>{
                if (!entry.isIntersecting){
                    return
                }
                entry.target.classList.add("appear")
                const img = entry.target.getElementsByTagName("img")[0]
                img.setAttribute('src', img.getAttribute("data-lazy"))
                //load once, then stop watching so scrolling doesn't re-set src
                observer.unobserve(entry.target)
            })
        },{
            threshold: 0
        })
    }
    componentDidMount(){
        this.fetchProjects()
    }
    fetchProjects = () => {
        if (this.fetchingMore || !this.state.hasMore){
            return
        }
        this.fetchingMore = true
        fetch(`/api/store/project/list?offset=${this.state.data.length}&limit=${PAGE_SIZE}`)
        .then(res => res.json())
        .then(data => {
            if (has(data, "error")){ throw data }
            this.fetchingMore = false
            this.setState(state => ({
                data: state.data.concat(data.results),
                hasMore: data.results.length === PAGE_SIZE,
                isLoading: false
            }), () => {
                //observe() delivers an initial entry, so re-observing fetches the
                //next page immediately if the sentinel is still on screen
                if (this.sentinel){
                    this.loadMoreObserver.unobserve(this.sentinel)
                    this.loadMoreObserver.observe(this.sentinel)
                }
            })
        })
        .catch(data => {
            this.fetchingMore = false
            this.setState({error: `Server: ${data.error}`, isLoading: false})
        })
    }
    sentinelRef = (sentinel) => {
        this.sentinel = sentinel
        if (sentinel){
            this.loadMoreObserver.observe(sentinel)
        } else {
            this.loadMoreObserver.disconnect()
        }
    }
    componentDidUpdate(){
        //observing an already-observed element is a no-op, so re-observe everything
        //except cards that already loaded their image (re-observing would refire
        //the callback and re-set their src)
        document.querySelectorAll(".gameCard:not(.appear)").forEach(card =>{
            this.observer.observe(card)
        })
    }
    componentWillUnmount(){
        this.applySearchFilter.cancel()
        this.observer.disconnect()
        this.loadMoreObserver.disconnect()
    }
    getGameListing = () => {
        return this.state.data
            .filter(project =>
                //if name contains the filter
                project.name?.toLowerCase()
                .includes(
                    this.state.searchFilter.toLowerCase()) ||
                //if the author contains the search
                project.author?.toLowerCase()
                .includes(
                    this.state.searchFilter.toLowerCase())
                )
            .filter(project => this.state.greenlitFilter === true
                ? project.greenlit === true
                : true)
            .map(project => <GameCard imgUrl={`/api/store/project/${project.id}/image`}
                gameName={project.name} gameAuthor={project.author}
                upvoteCount={project.upvoteCount}
                key={project.id} id={project.id} isPrivate={project.private} isPublic={project.public} isOpenSource={project.openSource}
                />)
    }
    applySearchFilter = debounce((value) => {
        this.setState({searchFilter: value})
    }, 300)
    handleSearch = (e) =>{
        this.applySearchFilter(e.target.value)
    }
    toggleGreenlitFilter = (filterOn) =>{
        this.setState({greenlitFilter: filterOn})
    }
    render() {
        if (this.state.error !== ""){
            return(
                <Error error={this.state.error} />
            )
        }
        return (
            <div className={`${this.state.isLoading=== true ? "loadingWrapper" : "mainContent"}`} style={{width:"100%", backgroundColor: "#f8f8f8"}}>
                {this.state.isLoading === true
                    ? <div className="loading"><FontAwesomeIcon icon={faSpinner} spin /></div>
                    :<>
                    <Header handleSearch={this.handleSearch} toggleGreenlitFilter={this.toggleGreenlitFilter}/>
                    <div className="gameListing" role="main">
                        {this.getGameListing()}
                    </div>
                    {this.state.hasMore &&
                        <div ref={this.sentinelRef} className="loading" aria-hidden="true">
                            <FontAwesomeIcon icon={faSpinner} spin />
                        </div>
                    }
                    </>
                }
            </div>
        )
    }
}

export default Gallery